import type { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import type { BulletProps } from 'components/Bullet/Bullet';
import type { IBody } from 'components/generic/typography/components/Body';
import Status from 'components/Status';
import type { StatusProps } from 'components/Status/StatusDefault';

export type StatusItemProps = PropsWithChildren &
    IBody & {
        statusRenderer?: () => JSX.Element;
        color?: StatusProps['color'];
        bulletSize?: BulletProps['size'];
    };

const StatusItemContainer = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.Spacing8};
`;

const StyledStatus = styled(Status)<{ size: StatusItemProps['bulletSize'] }>`
    ${({ size }) =>
        (size === 6 &&
            css`
                margin-top: ${({ theme }) => theme.Spacing8};
            `) ||
        ((size === 8 || size === 10) &&
            css`
                margin-top: ${({ theme }) => theme.Spacing6};
            `) ||
        (
            size === 12 &&
                css`
                margin-top: ${({ theme }) => theme.Spacing4};
            `
        )}
`;

function DefaultStatus(props: StatusItemProps) {
    return <StyledStatus color={props.color} size={props.bulletSize} />;
}

function StatusItem(props: StatusItemProps) {
    const { children, statusRenderer = DefaultStatus, ...restProps } = props;

    return (
        <StatusItemContainer {...restProps}>
            {statusRenderer(props)}
            <span>{children}</span>
        </StatusItemContainer>
    );
}

export default StatusItem;
